var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--noto",
    preserveAspectRatio: "xMidYMid meet",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.8 23.1L81.7 63.5c-.4.7-.4 1.5 0 2.2l29.1 42.3c1.2 1.8-1 3.9-2.8 2.8L65.1 82.2c-.7-.4-1.5-.4-2.2 0L20 110.8c-1.8 1.2-3.9-1-2.8-2.8l29.1-42.3c.4-.7.4-1.5 0-2.2L17.2 23.1c-1.2-1.8 1-3.9 2.8-2.8l42.9 26.6c.7.4 1.5.4 2.2 0L108 20.3c1.8-1.1 3.9 1 2.8 2.8z",
    fill: "#63df20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66 5.6l8.4 46.5c.2.8.8 1.4 1.5 1.5l46.5 8.4c2.1.5 2.1 3.5 0 3.9l-46.6 8.4c-.8.2-1.4.8-1.5 1.5L66 122.4c-.4 2.1-3.5 2.1-3.9 0l-8.4-46.6c-.2-.8-.8-1.4-1.5-1.5L5.6 66c-2.1-.4-2.1-3.5 0-3.9l46.5-8.4c.8-.2 1.4-.8 1.5-1.5L62 5.6c.5-2.1 3.5-2.1 4 0z",
    fill: "#8cff00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.65 57.02c-2.26 1.44-6.3 1.44-6.3 3.18c0 1.28 2.31 1.28 4.77 1.28c3.49-.05 6.41-.36 7.84-1.54c1.44-1.18 1.9-3.13 2.05-7.07c.15-4.72-.21-5.54-1.38-5.54c-1.55 0-2.52 6.92-6.98 9.69z",
    opacity: 0.75,
    fill: "#e2ff52"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.ad803a6983cf2e0cef9c75c024b27f27.svg";
export { ForwardRef as ReactComponent };